import Api from '@/services/Api'

export default {
  getScrambles (params) {
    return Api().get('tpc/rounds/list_scrambles', {params})
  },
  openedScrambles (params) {
    return Api().post('tpc/rounds/opened_scrambles', params)
  },
  submitResults (params) {
    return Api().post('tpc/rounds/submit_results', params)
  },
  addVideoLink (params) {
    return Api().post('tpc/rounds/add_video_link', params)
  },

  listResults (type, params) {
    return Api().get('tpc/rounds/list_results/' + type, {params})
  },

  listEvents (params) {
    return Api().get('tpc/rounds/list_events', {params})
  },
  getEventInfo (params) {
    return Api().get('tpc/rounds/event_info', {params})
  },
  getRegisteredRounds () {
    return Api().get('tpc/rounds/your_rounds', {})
  },

  registerRound (params) {
    return Api().post('tpc/rounds/register_round', params)
  },

  getLeaderboard (params) {
    return Api().get('tpc/rounds/leaderboard', {params})
  },
}
